<template>
  <div class="vx-row">
    <div class="vx-col w-2/3 mb-base">
      <reports-menu/>
    </div>
  </div>
</template>

<script>
import ReportsMenu from './../components/ReportsMenu.vue'

export default {
  components: {
    ReportsMenu
  }
};
</script>